import { Component, OnInit } from '@angular/core';
import { PersonService } from '../../service/person.service'; 

@Component({
	selector: 'app-my-q-and-a',
	templateUrl: './my-q-and-a.component.html',
	styleUrls: ['./my-q-and-a.component.styl', '../../share/modal/modal.component.styl']
})
export class MyQAndAComponent implements OnInit{
	tabIndex: number = 1;		// 1: My Questions 2: My Answers
	subTabIndex: number = 1;	// 1: To be answered 2: Answered
	myQuestionList: any[] = [1, 2, 3];
	myAnswerList: any[] = [1, 2, 3];
	questionStatus: any = {1: 'To be answered', 2: 'Under Approval', 3: 'Failure Audit'};
	page: any = {
		pageIndex: 1,
		pageCount: 1,
	};
	modal: any = {
		show: false,
		isEdit: false,
		questionId: '',
		answer: '',
		btnDisabled: false,
		tipText: '',
	};

	constructor(private personService: PersonService){}

	ngOnInit(){
		this.getMyQuestion();
	}

	// tab切换
	tabChange(tab: number){
		if (this.tabIndex === tab) return;
		this.tabIndex = tab;
		this.tabIndex === 1 ? this.getMyQuestion() : this.getMyAnswer();
	}

	// subTab切换
	subTabChange(subTab: number) {
		if (this.subTabIndex === subTab) return;
		this.subTabIndex = subTab;
		this.tabIndex === 1 ? this.getMyQuestion() : this.getMyAnswer();
	}

	// 获取我的问题
	getMyQuestion(pageIndex = 1){
		const status = this.subTabIndex === 1 ? 1 : 4;
		this.page.pageIndex = pageIndex;
		this.personService.getMyQuestion(status, pageIndex).subscribe(res => {
			if (res.status === 200){
				this.myQuestionList = res.rows || [];
				this.page.pageCount = Math.ceil(res.total / 10);
			}
		});
	}

	// 获取我的回答
	getMyAnswer(pageIndex = 1){
		const status = this.subTabIndex === 1 ? '1,2,3' : 4;
		this.page.pageIndex = pageIndex;
		this.personService.getMyAnswer(status, pageIndex).subscribe(res => {
			if (res.status === 200){
				this.myAnswerList = res.rows || [];
				this.page.pageCount = Math.ceil(res.total / 10);
			}
		});
	}
	
	// 页码点击事件
	onShowPage(page: number){
		this.tabIndex === 1 ? this.getMyQuestion(page) : this.getMyAnswer(page);
	}

    // 回答问题-弹窗
    modalShow(question: any){
        this.modal.show = true;
		this.modal.questionId = question.questionId;
		this.modal.isEdit = question.status === 3;
		if (this.modal.isEdit) this.modal.answer = question.answer;
    }
    modalCancel(){
        this.modal = {
            show: false,
            isEdit: false,
            questionId: '',
            answer: '',
            btnDisabled: false,
            tipText: '',
        };
    }
    modalOk(){
        if (!this.modal.answer || !this.modal.answer.trim()){
			this.modal.tipText = 'answer cannot be empty';
			return;
		}
		const { questionId, answer } = this.modal;
		this.modal.btnDisabled = true;
		this.personService.answerQuestion(questionId, answer).subscribe(res => {
			this.modal.btnDisabled = false;
			if (res.status === 200){
                this.modalCancel();
				this.getMyAnswer();
			}else{
				this.modal.tipText = res.msg;
			}
		});
    }
}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/person/my-q-and-a/my-q-and-a.component.ts